export const ENABLED_TRACKING_STATUSES = ['CREATED', 'RELEASED', 'SUBMITTED'];
